import { getAuthenticatedHttpClient, getHttpClient, getSiteConfig } from '@openedx/frontend-base';
import * as QueryString from 'query-string';

import { normalizeRedirectUrl } from '../../data/utils';

const registerNewUserApi = async (registrationInformation) => {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    isPublic: true,
  };
  const url = `${getSiteConfig().lmsBaseUrl}/api/user/v2/account/registration/`;
  const { data } = await getAuthenticatedHttpClient()
    .post(url, QueryString.stringify(registrationInformation), requestConfig)
    .catch((e: any) => {
      throw (e);
    });

  return {
    redirectUrl: normalizeRedirectUrl(data.redirect_url || ''),
    success: data.success || false,
    authenticatedUser: data.authenticated_user,
  };
};

const getFieldsValidations = async (formPayload) => {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  };
  const url = `${getSiteConfig().lmsBaseUrl}/api/user/v1/validation/registration`;
  const { data } = await getHttpClient()
    .post(
      url, QueryString.stringify(formPayload), requestConfig)
    .catch((e) => {
      throw (e);
    });

  return {
    fieldValidations: data,
  };
};

export {
  registerNewUserApi,
  getFieldsValidations,
};
